var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"testid",rawName:"v-testid",value:('skeleton'),expression:"'skeleton'"}],class:_vm.$style['skeleton']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }